export default __webpack_public_path__ + "static/media/milestone 350.bd3d7a76.svg";